import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import Layout from '../components/Layout';
import DashboardContent from '../components/DashboardContent';

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        // First check if user is logged in (has token)
        if (!authService.isAuthenticated()) {
          navigate('/login');
          return;
        }

        // Fetch fresh user data from API
        const response = await authService.getProfile();
        if (response && response.user) {
          setUser(response.user);
        } else {
          // Fallback to localStorage if API fails
          const userData = authService.getCurrentUser();
          if (userData) {
            setUser(userData);
          } else {
            navigate('/login');
          }
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
        // Fallback to localStorage if API fails
        const userData = authService.getCurrentUser();
        if (userData) {
          setUser(userData);
        } else {
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100">
        <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mb-5"></div>
        <p className="text-lg font-medium font-poppins text-gray-300">Loading dashboard...</p>
      </div>
    );
  }

  return (
    <Layout>
      <DashboardContent user={user} />
    </Layout>
  );
};

export default Dashboard;